import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../Redux/Slices/adminPortalSlice';
import './Charts.css';




let options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: 0,
    plugins: {
        legend: {
            position: 'left',
            display: true,
        },
        title: {
            color: 'rgba(0,0,0,0.7)',
            display: true,
            text: 'Language Selection Rate',
            font: {
                size: 20,
            },
        },
        tooltip: {
            displayColors: true,
            intersect: false,
            callbacks: {
                label: function (context) {
                    return ` ${context.label}: ${context.dataset.data[context.dataIndex]}%`;
                },
            }
        },
    }
};

const Doughnut2 = () => {
    let fetchedData = useSelector(analysisData);
    return (
        <div className="doughnut_Div">
            <Doughnut data={get_data(fetchedData.languageSelected)} options={options} />
        </div>
    );
}

export default Doughnut2;


function get_data(language) {
    let English = (language.english/(language.english + language.urdu)*100).toFixed(0)
    let Urdu = (language.urdu/(language.english + language.urdu)*100).toFixed(0)
    const data = {
        labels: ['English', 'Urdu'],
        datasets: [
            {
                label: 'Language',
                data: [English, Urdu],
                backgroundColor: [
                    'rgba(251, 140, 0, 0.4)',
                    'rgba(0, 230, 118, 0.4)',
                ],
                borderColor: [
                    'rgba(251, 140, 0, 1)',
                    'rgba(0, 230, 118, 1)',
                ],
                borderWidth: 1.2,
            },
        ],
    };

    return (data);
}